import { TerritorySwitch } from "@PegasusCore/pegasus-one-territory/src/script.js";
import { IpDetectionBar } from "@PegasusCore/pegasus-one-territory/src/script.js";
import Alpine from "alpinejs";

// Override the original classes
export class MyTerritorySwitch extends TerritorySwitch {
    formatSelector(selector) {
        // Add your custom functionality here to format the selector. Such as:
        pegasus.selectField(selector, {
            openOnHover: false,
            itemsToShow: 5,
            firstItemDisabled: true,
            classNames: {
                outerWrapper: "",
                selector:
                    "Form__Selector bg-white text-black -no-cancel w-full cursor-pointer flex text-left relative focus:outline-none py-2 pr-1",
                selectorOpen: "-open",
                selectionList:
                    "Form__Selector-list w-full bg-white text-black rounded-b-md -open",
                listItem:
                    "select-none relative transition duration-300 py-2 px-2 rounded-md",
                listItemFocus: "bg-beige-50",
            },
        });
    }
    // Optionally you can override the other methods as well
}
// At the end, replace the original class with the new one
Alpine.data("territorySwitch", () => new MyTerritorySwitch());

// You can do the same thing with the IpDetectionBar
export class MyIpDetectionBar extends IpDetectionBar {

    currentTerritory = null;

    constructor(currentTerritory) {
        super();

        if(currentTerritory) {
            this.currentTerritory = currentTerritory;   
        }
    }

    init() {
        super.init();

        const selectorOptions = this.selector.querySelectorAll("option");
        
        selectorOptions.forEach((option) => {
            if(option.dataset.territoryId === this.currentTerritory) {
                // Set this options value as the value of the selector
                this.selector.value = option.value;
                this.selector.dispatchEvent(new Event("change"));

                this.$root.querySelector(`[id="ip-select-${option.value}"]`).classList.add("-selected");
            }
        });

        this.$root.querySelectorAll("li").forEach((el) => {
            el.addEventListener("click", e => {
    
                this.$root.querySelectorAll(".-selected").forEach((el) => {
                    el.classList.remove("-selected");
                });
    
                e.currentTarget.classList.add("-selected");

                // this.$root.querySelector('.Form__Selector').dispatchEvent(new Event("click"));
            })
        });

       

    }


    formatSelector(selector) {
        pegasus.selectField(selector, {
            openOnHover: false,
            itemsToShow: 5,
            firstItemDisabled: true,
            classNames: {
                outerWrapper: "",
                selector:
                    "Form__Selector  -no-cancel w-full cursor-pointer flex text-left relative focus:outline-none py-2 pr-1",
                selectorOpen: "-open",
                selectionList:
                    "Form__Selector-list w-full bg-white text-black rounded-b-md -open overflow-hidden border border-beige-50",
                listItem:
                    "select-none relative transition duration-300 py-2 px-2 rounded-sm",
                listItemFocus: "bg-beige-50",
            },
        });
    }
}
Alpine.data("ipDetectionBar", (currentTerritory) => new MyIpDetectionBar(currentTerritory));
